import { render } from "./section-search-select.vue?vue&type=template&id=8f52381c&scoped=true"
import script from "./section-search-select.vue?vue&type=script&lang=js"
export * from "./section-search-select.vue?vue&type=script&lang=js"

import "@/assets/scss/retail/section-search-select.scss?vue&type=style&index=0&id=8f52381c&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f52381c"]])

export default __exports__